export default __webpack_public_path__ + "psn-frame.78460f794725360ea597095fb4993251.css";